/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BindOrCloseContractPayloadDto,
  BindingDataResponseDto,
  ContractAdjustmentPayloadDto,
  ContractAdjustmentResponseDto,
  ContractAllocationForClaimPaginationResponseDto,
  ContractFilterOptionsQueryDto,
  ContractFilterOptionsResponseDto,
  ContractFilterQueryDto,
  ContractPaginationResponseDto,
  ContractResponseDto,
  ErrorResponse,
  GetBindingDataQueryDto,
  TotalValuePerBinderResponseDto,
  UpdateContractPayloadDto,
  UpdateContractPremiumProcessingDataPayloadDto,
  UploadContractSlipPayloadDto,
  UpsertContractPayloadDto,
} from '../models/index';
import {
    BindOrCloseContractPayloadDtoFromJSON,
    BindOrCloseContractPayloadDtoToJSON,
    BindingDataResponseDtoFromJSON,
    BindingDataResponseDtoToJSON,
    ContractAdjustmentPayloadDtoFromJSON,
    ContractAdjustmentPayloadDtoToJSON,
    ContractAdjustmentResponseDtoFromJSON,
    ContractAdjustmentResponseDtoToJSON,
    ContractAllocationForClaimPaginationResponseDtoFromJSON,
    ContractAllocationForClaimPaginationResponseDtoToJSON,
    ContractFilterOptionsQueryDtoFromJSON,
    ContractFilterOptionsQueryDtoToJSON,
    ContractFilterOptionsResponseDtoFromJSON,
    ContractFilterOptionsResponseDtoToJSON,
    ContractFilterQueryDtoFromJSON,
    ContractFilterQueryDtoToJSON,
    ContractPaginationResponseDtoFromJSON,
    ContractPaginationResponseDtoToJSON,
    ContractResponseDtoFromJSON,
    ContractResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetBindingDataQueryDtoFromJSON,
    GetBindingDataQueryDtoToJSON,
    TotalValuePerBinderResponseDtoFromJSON,
    TotalValuePerBinderResponseDtoToJSON,
    UpdateContractPayloadDtoFromJSON,
    UpdateContractPayloadDtoToJSON,
    UpdateContractPremiumProcessingDataPayloadDtoFromJSON,
    UpdateContractPremiumProcessingDataPayloadDtoToJSON,
    UploadContractSlipPayloadDtoFromJSON,
    UploadContractSlipPayloadDtoToJSON,
    UpsertContractPayloadDtoFromJSON,
    UpsertContractPayloadDtoToJSON,
} from '../models/index';

export interface BindOrCloseContractRequest {
    contractId: string;
    bindOrCloseContractPayloadDto: BindOrCloseContractPayloadDto;
}

export interface ContractAdjustmentRequest {
    contractId: string;
    contractAdjustmentPayloadDto: ContractAdjustmentPayloadDto;
}

export interface ContractGetAdjustmentDetailRequest {
    contractAdjustmentId: string;
}

export interface ContractListAdjustmentsRequest {
    contractId: string;
}

export interface DeleteContractRequest {
    contractId: string;
}

export interface FilterContractsRequest {
    contractFilterQueryDto: ContractFilterQueryDto;
    field?: FilterContractsFieldEnum;
    order?: FilterContractsOrderEnum;
    page?: number;
    pageSize?: number;
}

export interface GetBindingDataRequest {
    getBindingDataQueryDto: GetBindingDataQueryDto;
}

export interface GetContractAllocationForClaimRequest {
    lineOfBusiness: string;
    insuredId?: string;
    claimId?: string;
    isRegistered?: boolean;
    page?: number;
    pageSize?: number;
}

export interface GetContractByIdRequest {
    contractId: string;
    includeAdjustmentCount?: boolean;
    applyAdjustments?: boolean;
}

export interface GetFilterOptionsRequest {
    contractFilterOptionsQueryDto: ContractFilterOptionsQueryDto;
}

export interface GetTotalValuePerBinderRequest {
    submissionId: string;
}

export interface UpdateContractByIdRequest {
    contractId: string;
    updateContractPayloadDto: UpdateContractPayloadDto;
}

export interface UpdateContractPremiumProcessingDataRequest {
    contractId: string;
    updateContractPremiumProcessingDataPayloadDto: UpdateContractPremiumProcessingDataPayloadDto;
}

export interface UploadContractSlipRequest {
    contractId: string;
    uploadContractSlipPayloadDto: UploadContractSlipPayloadDto;
}

export interface UpsertContractRequest {
    upsertContractPayloadDto: UpsertContractPayloadDto;
}

/**
 * 
 */
export class ContractApi extends runtime.BaseAPI {

    /**
     * Bind or close contract with premium schedule updates
     */
    async bindOrCloseContractRaw(requestParameters: BindOrCloseContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling bindOrCloseContract().'
            );
        }

        if (requestParameters['bindOrCloseContractPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'bindOrCloseContractPayloadDto',
                'Required parameter "bindOrCloseContractPayloadDto" was null or undefined when calling bindOrCloseContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}/bind-or-close`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: BindOrCloseContractPayloadDtoToJSON(requestParameters['bindOrCloseContractPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractResponseDtoFromJSON(jsonValue));
    }

    /**
     * Bind or close contract with premium schedule updates
     */
    async bindOrCloseContract(requestParameters: BindOrCloseContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractResponseDto> {
        const response = await this.bindOrCloseContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Contract adjustment
     */
    async contractAdjustmentRaw(requestParameters: ContractAdjustmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling contractAdjustment().'
            );
        }

        if (requestParameters['contractAdjustmentPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'contractAdjustmentPayloadDto',
                'Required parameter "contractAdjustmentPayloadDto" was null or undefined when calling contractAdjustment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}/adjustment`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContractAdjustmentPayloadDtoToJSON(requestParameters['contractAdjustmentPayloadDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Contract adjustment
     */
    async contractAdjustment(requestParameters: ContractAdjustmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.contractAdjustmentRaw(requestParameters, initOverrides);
    }

    /**
     * Get contract adjustment detail by adjustment ID
     */
    async contractGetAdjustmentDetailRaw(requestParameters: ContractGetAdjustmentDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractAdjustmentResponseDto>> {
        if (requestParameters['contractAdjustmentId'] == null) {
            throw new runtime.RequiredError(
                'contractAdjustmentId',
                'Required parameter "contractAdjustmentId" was null or undefined when calling contractGetAdjustmentDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/adjustment/{contractAdjustmentId}`.replace(`{${"contractAdjustmentId"}}`, encodeURIComponent(String(requestParameters['contractAdjustmentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractAdjustmentResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract adjustment detail by adjustment ID
     */
    async contractGetAdjustmentDetail(requestParameters: ContractGetAdjustmentDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractAdjustmentResponseDto> {
        const response = await this.contractGetAdjustmentDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List contract adjustments by contract ID
     */
    async contractListAdjustmentsRaw(requestParameters: ContractListAdjustmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ContractAdjustmentResponseDto>>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling contractListAdjustments().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}/adjustments`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContractAdjustmentResponseDtoFromJSON));
    }

    /**
     * List contract adjustments by contract ID
     */
    async contractListAdjustments(requestParameters: ContractListAdjustmentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ContractAdjustmentResponseDto>> {
        const response = await this.contractListAdjustmentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete contract by id
     */
    async deleteContractRaw(requestParameters: DeleteContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling deleteContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete contract by id
     */
    async deleteContract(requestParameters: DeleteContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteContractRaw(requestParameters, initOverrides);
    }

    /**
     * Filter contracts
     */
    async filterContractsRaw(requestParameters: FilterContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractPaginationResponseDto>> {
        if (requestParameters['contractFilterQueryDto'] == null) {
            throw new runtime.RequiredError(
                'contractFilterQueryDto',
                'Required parameter "contractFilterQueryDto" was null or undefined when calling filterContracts().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['field'] != null) {
            queryParameters['field'] = requestParameters['field'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/filter`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContractFilterQueryDtoToJSON(requestParameters['contractFilterQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Filter contracts
     */
    async filterContracts(requestParameters: FilterContractsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractPaginationResponseDto> {
        const response = await this.filterContractsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get binding data
     */
    async getBindingDataRaw(requestParameters: GetBindingDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BindingDataResponseDto>>> {
        if (requestParameters['getBindingDataQueryDto'] == null) {
            throw new runtime.RequiredError(
                'getBindingDataQueryDto',
                'Required parameter "getBindingDataQueryDto" was null or undefined when calling getBindingData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/get-binding-data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetBindingDataQueryDtoToJSON(requestParameters['getBindingDataQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BindingDataResponseDtoFromJSON));
    }

    /**
     * Get binding data
     */
    async getBindingData(requestParameters: GetBindingDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BindingDataResponseDto>> {
        const response = await this.getBindingDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contract allocation for claim
     */
    async getContractAllocationForClaimRaw(requestParameters: GetContractAllocationForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractAllocationForClaimPaginationResponseDto>> {
        if (requestParameters['lineOfBusiness'] == null) {
            throw new runtime.RequiredError(
                'lineOfBusiness',
                'Required parameter "lineOfBusiness" was null or undefined when calling getContractAllocationForClaim().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['insuredId'] != null) {
            queryParameters['insuredId'] = requestParameters['insuredId'];
        }

        if (requestParameters['lineOfBusiness'] != null) {
            queryParameters['lineOfBusiness'] = requestParameters['lineOfBusiness'];
        }

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['isRegistered'] != null) {
            queryParameters['isRegistered'] = requestParameters['isRegistered'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/allocation-for-claim`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractAllocationForClaimPaginationResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract allocation for claim
     */
    async getContractAllocationForClaim(requestParameters: GetContractAllocationForClaimRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractAllocationForClaimPaginationResponseDto> {
        const response = await this.getContractAllocationForClaimRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get contract by id
     */
    async getContractByIdRaw(requestParameters: GetContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling getContractById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeAdjustmentCount'] != null) {
            queryParameters['includeAdjustmentCount'] = requestParameters['includeAdjustmentCount'];
        }

        if (requestParameters['applyAdjustments'] != null) {
            queryParameters['applyAdjustments'] = requestParameters['applyAdjustments'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get contract by id
     */
    async getContractById(requestParameters: GetContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractResponseDto> {
        const response = await this.getContractByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get available filter options for contract list
     */
    async getFilterOptionsRaw(requestParameters: GetFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractFilterOptionsResponseDto>> {
        if (requestParameters['contractFilterOptionsQueryDto'] == null) {
            throw new runtime.RequiredError(
                'contractFilterOptionsQueryDto',
                'Required parameter "contractFilterOptionsQueryDto" was null or undefined when calling getFilterOptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/filter-options`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ContractFilterOptionsQueryDtoToJSON(requestParameters['contractFilterOptionsQueryDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractFilterOptionsResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get available filter options for contract list
     */
    async getFilterOptions(requestParameters: GetFilterOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractFilterOptionsResponseDto> {
        const response = await this.getFilterOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get total value per binder
     */
    async getTotalValuePerBinderRaw(requestParameters: GetTotalValuePerBinderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TotalValuePerBinderResponseDto>>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling getTotalValuePerBinder().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['submissionId'] != null) {
            queryParameters['submissionId'] = requestParameters['submissionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/total-value-per-binder`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TotalValuePerBinderResponseDtoFromJSON));
    }

    /**
     * Get total value per binder
     */
    async getTotalValuePerBinder(requestParameters: GetTotalValuePerBinderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TotalValuePerBinderResponseDto>> {
        const response = await this.getTotalValuePerBinderRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update contract by id
     */
    async updateContractByIdRaw(requestParameters: UpdateContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling updateContractById().'
            );
        }

        if (requestParameters['updateContractPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateContractPayloadDto',
                'Required parameter "updateContractPayloadDto" was null or undefined when calling updateContractById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContractPayloadDtoToJSON(requestParameters['updateContractPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update contract by id
     */
    async updateContractById(requestParameters: UpdateContractByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractResponseDto> {
        const response = await this.updateContractByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update contract premium processing data
     */
    async updateContractPremiumProcessingDataRaw(requestParameters: UpdateContractPremiumProcessingDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling updateContractPremiumProcessingData().'
            );
        }

        if (requestParameters['updateContractPremiumProcessingDataPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'updateContractPremiumProcessingDataPayloadDto',
                'Required parameter "updateContractPremiumProcessingDataPayloadDto" was null or undefined when calling updateContractPremiumProcessingData().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}/premium-processing-data`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContractPremiumProcessingDataPayloadDtoToJSON(requestParameters['updateContractPremiumProcessingDataPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractResponseDtoFromJSON(jsonValue));
    }

    /**
     * Update contract premium processing data
     */
    async updateContractPremiumProcessingData(requestParameters: UpdateContractPremiumProcessingDataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractResponseDto> {
        const response = await this.updateContractPremiumProcessingDataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upload contract slip
     */
    async uploadContractSlipRaw(requestParameters: UploadContractSlipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractResponseDto>> {
        if (requestParameters['contractId'] == null) {
            throw new runtime.RequiredError(
                'contractId',
                'Required parameter "contractId" was null or undefined when calling uploadContractSlip().'
            );
        }

        if (requestParameters['uploadContractSlipPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'uploadContractSlipPayloadDto',
                'Required parameter "uploadContractSlipPayloadDto" was null or undefined when calling uploadContractSlip().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract/{contractId}/upload-slip`.replace(`{${"contractId"}}`, encodeURIComponent(String(requestParameters['contractId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UploadContractSlipPayloadDtoToJSON(requestParameters['uploadContractSlipPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractResponseDtoFromJSON(jsonValue));
    }

    /**
     * Upload contract slip
     */
    async uploadContractSlip(requestParameters: UploadContractSlipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractResponseDto> {
        const response = await this.uploadContractSlipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Upsert contract
     */
    async upsertContractRaw(requestParameters: UpsertContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ContractResponseDto>> {
        if (requestParameters['upsertContractPayloadDto'] == null) {
            throw new runtime.RequiredError(
                'upsertContractPayloadDto',
                'Required parameter "upsertContractPayloadDto" was null or undefined when calling upsertContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/contract`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpsertContractPayloadDtoToJSON(requestParameters['upsertContractPayloadDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ContractResponseDtoFromJSON(jsonValue));
    }

    /**
     * Upsert contract
     */
    async upsertContract(requestParameters: UpsertContractRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ContractResponseDto> {
        const response = await this.upsertContractRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const FilterContractsFieldEnum = {
    InceptionDate: 'inceptionDate',
    ExpiryDate: 'expiryDate',
    CreatedAt: 'createdAt',
    ContractStatus: 'contractStatus',
    PinnacleRefNo: 'pinnacleRefNo',
    Insured: 'insured',
    Reinsured: 'reinsured',
    SourceBroker: 'sourceBroker',
    Binder: 'binder',
    LineOfBusiness: 'lineOfBusiness',
    Underwriter: 'underwriter',
    UnderwritingYear: 'underwritingYear',
    LayerType: 'layerType',
    LimitHundredPercent: 'limitHundredPercent',
    ExcessHundredPercent: 'excessHundredPercent',
    LineSizePercent: 'lineSizePercent',
    NamedUnderwriter: 'namedUnderwriter'
} as const;
export type FilterContractsFieldEnum = typeof FilterContractsFieldEnum[keyof typeof FilterContractsFieldEnum];
/**
 * @export
 */
export const FilterContractsOrderEnum = {
    Asc: 'ASC',
    Desc: 'DESC'
} as const;
export type FilterContractsOrderEnum = typeof FilterContractsOrderEnum[keyof typeof FilterContractsOrderEnum];
